import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonModal, useIonViewWillEnter } from '@ionic/react'
import { restaurantCenter, productMobx, discountMobx, doProductMobx, doComboMobx, productCenter, restaurantConfig } from 'restaurant'
import { storeMobx, themeMobx } from '@mobxStore'
import { ProductDetail, ComboDetail } from './component'
import { useHistoryNew, getPlatform, miniAppRouteTo } from '@utils'
import NoSearchImg from '@img/no_search.png'
import './index.scss'

/** 餐品详情页 */
const Detail: React.FC = (props: any) => {
  const isModal = props.isModal
  const isFullNFree = props.match?.params?.targetType === 'fullNFree' || props.match?.path?.match(/\/fullNFree/)
  const isCombo = props.match?.params?.productType === 'combo' || props.match?.path?.match(/\/combo/)
  const isPked = props.match?.params?.targetType === 'combo' && props.match?.params?.targetNo
  const [showInfo, setShowInfo] = useState(false)
  const [disableScale, setDisableScale] = useState(false)
  const [hideModifyDiscount, setHideModifyDiscount] = useState(false)
  const [targetType, setTargetType] = useState('')
  const [targetNo, setTargetNo] = useState('')
  const history = useHistoryNew()

  const productNo = props.match?.params?.productNo
  const isInMenu = productMobx.viewProducts.find(product => product.no === productNo)
  const { isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()

  const handleSet = (flag?: boolean) => {
    const params = props.match?.params
    if (params && flag) {
      if (isFullNFree) {
        setDisableScale(true)
        setHideModifyDiscount(true)
      } else {
        // if (params.productNo && !isPked) {
        //   isCombo ? doComboMobx.pick({ productNo: params.productNo }) : doProductMobx.pick({ productNo: params.productNo })
        // } else if (params.pk && !isPked) {
        //   isCombo ? doComboMobx.pick({ cartItemPk: params.pk }) : doProductMobx.pick({ cartItemPk: params.pk })
        // }
        if (params.pk && !isPked) {
          isCombo ? doComboMobx.pick({ cartItemPk: params.pk }) : doProductMobx.pick({ cartItemPk: params.pk })
        } else if (params.productNo && !isPked) {
          if (isCombo) {
            const ext = doComboMobx.doComboExt
            if (!doComboMobx.doComboExt?.isAddProduct) {
              doComboMobx.pick({ productNo: params.productNo })
            }
            doComboMobx.pickExt(ext)
          } else {
            const ext = doProductMobx.doProductExt
            if (!doProductMobx.doProductExt?.isAddProduct) {
              doProductMobx.pick({ productNo: params.productNo, initAdd: true })
            }
            if (doProductMobx.doProductExt?.isOrderSwapBuy) {
              setHideModifyDiscount(true)
            }
            doProductMobx.pickExt(ext)
          }
        }
      }
      if (params.scaleNo && !isCombo && !isFullNFree) {
        doProductMobx.selectScale(params.scaleNo)
        setDisableScale(true)
        setHideModifyDiscount(true)
      }
      if (params.targetType && params.targetNo) {
        setTargetNo(params.targetNo)
        setTargetType(params.targetType)
      }
    }
    if (!isCombo) {
      doProductMobx.restoreModifierGroup()
    }
    setShowInfo(true)
  }

  const handleCancel = () => {
    const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
    if (hasHome) {
      if (isWeixinMiniProgram) {
        miniAppRouteTo({
          url: '/pages/home/index'
        })
        return
      } else if (isAliPayMiniProgram) {
        miniAppRouteTo({
          url: '/pages/home/index'
        })
        return
      } else {
        history.replace('/home')
      }
    } else {
      history.replace('/menu')
    }
  }

  const renderPage = () => (
    <IonPage
      className='detail-page-modal'
    >
      {
        productCenter.isInited ? (
          productNo && isInMenu ? (isCombo ? <ComboDetail showInfo={showInfo} /> : <ProductDetail showInfo={showInfo} targetNo={targetNo} targetType={targetType} disableScale={disableScale} hideModifyDiscount={hideModifyDiscount} />) : (
            <div className='empty-info'>
              <img src={NoSearchImg} alt='' className='empty-info-pic' />
              <p className='empty-info-txt'>{i18n.t('menu.productOff')}</p>
              <div className='empty-info-btn' data-cypid='productDetailPageModalClose' onClick={handleCancel}>{i18n.t('common.back')}</div>
            </div>
          )
        ) : null
      }
    </IonPage>
  )

  const renderModal = () => (
    <IonModal
      isOpen
      cssClass='detail-page-modal'
    >
      {
        isCombo ? <ComboDetail isModal showInfo={showInfo} /> : <ProductDetail isModal showInfo={showInfo} targetNo={targetNo} targetType={targetType} disableScale={disableScale} hideModifyDiscount={hideModifyDiscount} />
      }
    </IonModal>
  )

  useIonViewWillEnter(() => {
    let time = 0
    if (!storeMobx.info.storeId) {
      storeMobx.initInfo(storeMobx.viewStoreList[0])
      time = 100
    }
    if (!productMobx.products?.length) {
      setTimeout(() => {
        restaurantCenter.init()
      }, time)
    }
  }, [history])

  useEffect(() => {
    if (isModal) {
      handleSet(true)
    } else {
      if (productMobx.viewProducts.length) {
        handleSet(true)
      } else {
        handleSet(history.action === 'PUSH')
      }
    }
  }, [isModal, productMobx.viewProducts, discountMobx.itemDiscountMap])

  useEffect(() => {
    if (history?.getPrevState() === '/menu' && productNo) {
      if (productNo !== doComboMobx?.doCombo?.no && productNo !== doProductMobx?.doProduct?.no) {
        handleSet(history.action === 'PUSH')
      }
    }
  }, [props.match])

  return (
    isModal ? renderModal() : renderPage()
  )
}

export default observer(Detail)
